<script>
  export let obj;
  import { user } from "../../firebase";
  import { Utils } from "../../utils";
  import { saveAs } from "file-saver";
  import FileSaver from "file-saver";
  import Preview from "./Preview.svelte";
  let img;
  let userinfo;
  let time = new Date(parseInt(obj.timestamp)).toISOString().substr(11, 5);
  console.log(new Date(obj.timestamp));
  $user.doc.subscribe((v) => {
    userinfo = v;
  });
  encodeURI;
  let urls = [];
  var pattern =
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gm;

  urls = obj.comment_text.match(pattern);
  let words;
  let tempMessage = obj.comment_text;
  urls = [...new Set(urls)];

  let message;
  if (urls) {
    urls.forEach((a) => {
      console.log(a);
      console.log("-----------------------------------");
      console.log(tempMessage.indexOf(a));
      console.log("-----------------------------------");
      tempMessage = tempMessage.replaceAll(
        a,
        '<a class="u-link" href="' + a + '" target="_blank">' + a + "</a>"
      );
      console.log(tempMessage);
    });
  }
  message = tempMessage;

  if (obj) {
    words = obj.comment_text.split(" ");
  }

  if (!words) {
  }

  let imagetype = [
    "jpg",
    "JPG",
    "png",
    "PNG",
    "jpeg",
    "JPEG",
    "svg",
    "SVG",
    "gif",
    "GIF",
  ];

  let preview = "";
  let Save = async (e) => {
    let link = Utils.file.tokenToLink(
      `stores/${$user.auth.claims.store}/${e.name}`,
      e.token
    );
    //FileSaver.saveAs(link, e.name);
    var blob = new Blob([link]);
    FileSaver.saveAs(blob, e.name);
  };

  console.log("(((((((((((((((((((((((((((((((((((((");
  console.log(obj);
  console.log("(((((((((((((((((----------((((((((((((((((((((");
</script>

{#if preview}
  <Preview bind:preview />
{/if}
{#if obj}
  <div class="commentContainer">
    <div class="leftSide">
      <div class="user-img">
        <img src={userinfo.account.img} alt="temp" />
      </div>
    </div>
    <div class="rightSide">
      <h3>
        <span>{time}</span>
        <div class="username">You</div>
      </h3>
      <div class="paragraphContainer">
        {#if obj.comment_text && obj.comment_text != " \n"}
          <div class="wrap">
            {#if message}
              <p style="white-space: pre-line;">{@html message}</p>
            {/if}
          </div>
        {/if}
        {#if obj.attachment}
          {#each obj.attachment as attach}
            {#if imagetype.includes(attach.type)}
              <div class="attach">
                <img
                  on:click={() => {
                    preview = Utils.file.tokenToLink(
                      `stores/${$user.auth.claims.store}/${attach.name}`,
                      attach.token
                    );
                  }}
                  class="attach-img"
                  src={Utils.file.tokenToLink(
                    `stores/${$user.auth.claims.store}/${attach.name}`,
                    attach.token
                  )}
                  alt=""
                />
              </div>
            {:else if attach.type == "zip"}
              <div class="attach">
                <img class="attach-img" src="../images/tasks/zip.svg" alt="" />
                <div class="attach-name">{attach.name}</div>
              </div>
            {:else}
              <div class="attach">
                <img class="attach-img" src="../images/tasks/file.svg" alt="" />
                <div class="attach-name">{attach.name}</div>
              </div>
            {/if}
          {/each}
        {/if}
      </div>
    </div>
  </div>
{/if}

<style>
  * {
    padding: 0;
    margin: 0;
  }

  .commentContainer {
    display: flex;
    flex-direction: row;
    flex-direction: row-reverse;
    margin-bottom: 1rem;
  }

  .leftSide i {
    font-size: 2em;
  }

  .rightSide {
    padding-right: 1rem;
  }

  .rightSide p {
    margin: 0 0.4em;
  }

  .rightSide h3 {
    display: flex;
    justify-content: flex-end;
    font-weight: 500;
    font-size: 1em;
    margin-bottom: 0.2rem;
    align-items: baseline;
  }

  .wrap {
    display: flex;
    font-weight: 400;
    font-size: 0.8em;
    background-color: #2c8f73;
    padding: 0.5rem 1rem;
    border-radius: 12px;
    border-top-right-radius: 0px;
    color: white;
    overflow-wrap: anywhere;
    flex-wrap: wrap;
    line-height: 1.8em;
  }

  a {
    color: #4fb0d7;
    margin: 0 0.4em;
    overflow-wrap: normal;
  }

  .paragraphContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .rightSide span {
    color: #7d8592;
    font-size: 0.7em;
    padding-right: 0.5rem;
  }

  .user-img {
    border-radius: 50%;
    display: flex;
    width: 2.5rem;
    height: 2.5rem;
    overflow: hidden;
  }
  .username {
    font-size: 0.85em;
    font-weight: 400;
    margin-right: 0.5rem;
  }

  .attach {
    margin: 0.1rem;
    width: 10rem;
    /* height: 6rem; */
  }

  .attach-img {
    border-radius: 12px;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .attach-name {
    text-align: center;
    font-size: 0.7em;
    line-break: anywhere;
    max-width: 100%;
  }
</style>
